export const ADD_IMAGE = 'Ação: Adicionar Imagem'
export const REMOVE_IMAGE = 'Ação: Remover Imagem'
export const MODIFY_IMAGE_SOURCE = 'Ação: Modificar fonte imagem'
export const MODIFY_IMAGE_DESC = 'Ação: Modificar descrição imagem'
export const DELETE_IMAGE = 'Ação: Deletar imagem completa'
export const DELETE_IMAGE_STORE = 'Ação : Deletar imagem completa na store'
export const CARREGAR_IMAGES_SERVER = 'Ação : Carregar imagens do server'
export const CARREGAR_IMAGES_STORE = 'Ação : Carregar imagens na store'
export const ADD_IMAGE_STORE = 'Ação : adicionar imagem na store'

export const EDITAR_INFORMACOES = 'Ação : editar informações de site'
export const CARREGAR_INFORMACOES_SERVER = 'Ação : carregar informações do site do server'

export const ADICIONAR_PESSOA_CORRETOR = 'Ação : adicionar pessoa como corretor do sistema'
export const EDITAR_INFORMACOES_CORRETOR = 'Ação : editar informações gerais de pessoa como corretor'
export const REMOVER_PESSOA_CORRETOR = 'Ação : remover pessoa como corretor do sistema começando pelo server'
export const REMOVER_PESSOA_CORRETOR_STORE = 'Ação : remover pessoa na store'
export const CARREGAR_CORRETORES_SERVER = 'Ação : carregar relação de corretores do server'
export const CARREGAR_CORRETORES_STORE = 'Ação : carregar relação de corretores na store'

export const CARREGAR_MAPA_POLYS = 'Ação : carregar polígonos do mapa do loteamento'
export const CARREGAR_MAPA_POLYS_SERVER = 'Ação : carregar do server polígonos do mapa do loteamento'

export const CARREGAR_LOTES_VENDA_SERVER = 'Ação : carregar informações de lotes de venda do server'
export const CARREGAR_LOTES_VENDA_STORE = 'Ação : carregar informações de lotes de venda na store'
export const ATUALIZAR_STATUS_VENDA_LOTE = 'Ação : modificar status de venda de lote específico'

export const CRIAR_PAGINA_SITE = 'Ação : criar página no site junto a um nome'
export const DELETAR_PAGINA_SITE = 'Ação : remover página no site'
export const EDITAR_PAGINA_SITE = 'Ação : editar página existente de site'
export const CARREGAR_PAGINAS_SERVER = 'Ação : carregar paginas do server'
export const CARREGAR_PAGINAS_NA_STORE = 'Ação : carregar páginas que foram passadas do server na store'

export const LOAD_REQUEST = 'Ação : carregar request externo, resultando em +1 na fila de feedback de loading'
export const FINISH_REQUEST = 'Ação : terminar request externo, resultando em -1 na fila de feedback de loading'

export const USUARIOS_LENGTH_ADD = 'Ação : +1 quantidade de usuarios'
export const USUARIOS_LENGTH_REMOVE = 'Ação : -1 quantidade de usuarios'

export const LOGIN = "Ação : login com usuário e senha"
export const LOGOUT = 'Ação : logout do usuário'
export const ALGO_ERRADO = 'Ação : algo de errado com o login'


// WEBPACK FOOTER //
// ./src/constants/constants.js